<template>
  <b-tabs
    v-model="tabIndex"
    content-class="mt-1"
  >
    <!-- This tabs content will always be mounted -->
    <b-tab
      title="Listado de clientes"
      lazy
    >
      <customers-list
        @addCustomerTab="newTab($event)"
      />
    </b-tab>

    <!-- This tabs content will not be mounted until the tab is shown and will be un-mounted when hidden -->
    <b-tab
      v-for="customer in customersTabs.filter(customer => customer.type === 'view')"
      :key="customer.id"
      :title="'Cliente #' + customer.id"
      lazy
    >
      <customers-view
        :customer-id="customer.id"
        @addEditTab="editTab(customer.id)"
        @closeTab="closeTab(customer.id, 'view')"
      />
    </b-tab>

    <b-tab
      v-for="customer in customersTabs.filter(customer => customer.type === 'edit')"
      :key="customer.id"
      :title="'Edición cliente #' + customer.id"
      lazy
    >
      <customers-edit
        v-if="customer.type === 'edit'"
        :customer-id="customer.id"
        @addCustomerTab="newTab($event)"
      />
    </b-tab>

    <!-- Close tab button -->
    <template
      v-if="customersTabs.length > 0"
      #tabs-end
    >
      <b-nav-item
        @click.prevent="closeTab(customersTabs[0].id, customersTabs[0].type)"
      >
        <b>x</b>
      </b-nav-item>
    </template>

  </b-tabs>
</template>

<script>
import CustomersList from './CustomersList.vue'
import CustomersView from './CustomersView.vue'
import CustomersEdit from './CustomersEdit.vue'

export default {
  components: {
    CustomersList,
    CustomersView,
    CustomersEdit,
  },

  data() {
    return {
      tabIndex: 0,
      customersTabs: [],
    }
  },

  watch: {
    '$route.params.id': function routeParamsIdWatcher(newId) {
      if (newId) {
        this.newTab(Number(newId))
      }
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.newTab(Number(this.$route.params.id))
    }
  },

  methods: {
    newTab(customerId) {
      this.customersTabs = []
      this.customersTabs.push({
        id: customerId,
        type: 'view',
      })
      setTimeout(() => {
        this.tabIndex = 1
      }, 100)
    },

    editTab(customerId) {
      this.customersTabs = []
      this.customersTabs.push({
        id: customerId,
        type: 'edit',
      })

      this.closeTab(customerId, 'view') // Close view tab before opening edit tab

      setTimeout(() => {
        this.tabIndex = 1
      }, 100)
    },

    closeTab(customerId, type) {
      for (let i = 0; i < this.customersTabs.length; i += 1) {
        if (this.customersTabs[i].id === customerId && this.customersTabs[i].type === type) {
          this.customersTabs.splice(i, 1)
        }
      }
      this.tabIndex = 0 // Redirect to list component
    },
  },
}
</script>
